import Wrapper from '@app/Wrapper.js'

Munio.ApiManager = class extends Wrapper {
  constructor(selector, client) {
    super(selector, { client })
  }

  get name() {
    return 'ApiManager'
  }

  component() {
    if (this.data.client) {
      return import('./Client.vue')
    }

    return import('./Clients.vue')
  }
}
